import { Translation } from 'cng-common/features/translations/components/translation'

import { TRANSLATION_KEYS } from '../../../../translations'

import styles from './InitiativesDialogHeader.module.scss'

export const InitiativesDialogHeader = () => {
  return (
    <h3 className={styles.root}>
      <Translation text={TRANSLATION_KEYS.initiativesDialog.dialogLabel} />
    </h3>
  )
}
